import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IUserEnteredSupplementDataWithComments } from '@interfaces/supplements';
import eventBus, { EventType } from '@utils/eventBus';

import {
  handleAdminCreateNewSupplement,
  handleAdminSupplementMarkAsMedication,
  handleAdminSupplementMatchExisting,
  handleAdminSupplementNeedsMoreInfo,
  handleGetAdminMatchingSupplement,
} from './actions';
import { IAdminNewSupplementState } from './slice.interface';

const initialState: IAdminNewSupplementState = {
  matchingSupplement: null,
  pendingNewSupplement: null,
};

export const adminNewSupplementSlice = createSlice({
  name: 'admin-new-supplement',
  initialState,
  reducers: {
    setAdminPendingNewSupplement: (
      state,
      action: PayloadAction<IUserEnteredSupplementDataWithComments | null>,
    ) => {
      state.pendingNewSupplement = action.payload;
    },
    removeAdminMatchingSupplement: state => {
      state.matchingSupplement = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAdminMatchingSupplement.pending, (state: IAdminNewSupplementState) => {
        state.matchingSupplement = null;
      })
      .addCase(
        handleGetAdminMatchingSupplement.fulfilled,
        (state: IAdminNewSupplementState, action) => {
          state.matchingSupplement = action.payload.data;
        },
      )
      .addCase(handleAdminCreateNewSupplement.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_CREATE_NEW_SUPPLEMENT_SUCCESS);
      })
      .addCase(handleAdminSupplementMatchExisting.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_MATCH_EXISTING_SUCCESS);
      })
      .addCase(handleAdminSupplementNeedsMoreInfo.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_MARKED_AS_NEEDS_MORE_INFO_SUCCESS);
      })
      .addCase(handleAdminSupplementMarkAsMedication.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_MARKED_AS_MEDICATION_SUCCESS);
      });
  },
});

export const { removeAdminMatchingSupplement, setAdminPendingNewSupplement } =
  adminNewSupplementSlice.actions;

export default adminNewSupplementSlice.reducer;
